type NonceValue = {
  nonce: string;
};

function isNonceValue(obj: unknown): obj is NonceValue {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  return "nonce" in obj;
}

export const initializeNonce = () => {
  const nonceElement = document.getElementById("nonce");

  if (!nonceElement) {
    throw new Error("Cannot find nonce element");
  }
  const json = nonceElement.textContent;
  if (!json) {
    throw new Error("Nonce element is empty");
  }
  const obj = JSON.parse(json);
  if (!isNonceValue(obj)) {
    throw new Error("Cannot parse nonce value");
  }
  return obj.nonce;
};
